
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/shopify",
      function () {
        return require("private-next-pages/whatsapp-integrations/shopify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/shopify"])
      });
    }
  